// resetMessageTranslationThrottleIds.js
'use strict';
import { SET_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Reset message translation throttle ids
 * @kind action
 * @return {Promise} Action promise.
 */
const resetMessageTranslationThrottleIds = () => async dispatch => {
  return dispatch({
    type: SET_OPERATION_DATA,
    payload: {
      selectPath: ['throttledMessageTranslation'],
      data: {
        groups: [],
      },
    },
  });
};

export default resetMessageTranslationThrottleIds;
